<template>
  <div class="stream-tab-body">
    <div class="stream-tab-body-header">
      Stream Logs Activities
      <b-tag v-if="stream_status == 'ACTIVE'" type="is-success">ACTIVE</b-tag>
      <b-tag v-else-if="stream_status == 'CONNECTED'" type="is-success is-light">CONNECTED</b-tag>
      <b-tag v-else-if="stream_status == 'DISCONNECTED'" type="is-warning">DISCONNECTED</b-tag>
      <b-tag v-else-if="stream_status == 'ERROR'" type="is-danger">ERROR</b-tag>
      <b-tag v-else-if="stream_status == 'CDN_UPLOADING'" type="is-warning is-light">CDN UPLOADING</b-tag>
      <b-tag v-else-if="stream_status == 'IDLE'" type="is-primary is-light">IDLE</b-tag>
    </div>
    <div class="stream-tab-body-body">
      <div class="stream-log-item" v-for="(item, index) in logs" :key="index">
        <div class="stream-log-item-label">
          <b-taglist attached>
            <b-tag type="is-dark">Live</b-tag>
            <b-tag type="is-primary"
              v-if="item.state != 'RECORDING_STOPPED' && item.state != 'RECORDING_STARTED'">Stream</b-tag>
            <b-tag type="is-light"
              v-if="item.state == 'RECORDING_STOPPED' || item.state == 'RECORDING_STARTED'">Record</b-tag>
            <b-tag type="is-success" v-if="item.state == 'RECORDING_STARTED'">Started</b-tag>
            <b-tag type="is-warning" v-if="item.state == 'RECORDING_STOPPED'">Ended</b-tag>
            <b-tag type="is-success" v-if="item.state == 'ACTIVE'">Active</b-tag>
            <b-tag type="is-warning" v-if="item.state == 'DISCONNECTED'">Disconnected</b-tag>
            <b-tag type="is-danger" v-if="item.state == 'ERROR'">Error</b-tag>
            <b-tag type="is-primary is-light" v-if="item.state == 'IDLE'">Idle</b-tag>
            <b-tag type="is-success is-light" v-if="item.state == 'CONNECTED'">Connected</b-tag>
            <b-tag type="is-warning is-light" v-if="item.state == 'CDN_UPLOADING'">CDN Uploading</b-tag>
          </b-taglist>
        </div>
        <div class="stream-log-item-value">{{ moment(item.createdAt).format("YYYY-MM-DD hh:mm:ss A") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    event: {
      type: Object,
      required: true,
    },
    streamKey: {
      type: String,
      required: true,
    }
  },
  data: () => ({
    logs: [],
    stream_status: "",
    get_logs_timer: null
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getStreamLogs();
    vm.get_logs_timer = setInterval(() => {
      vm.getStreamLogs();
    }, 1000 * 2);
  },
  beforeDestroy() {
    let vm = this;
    clearInterval(vm.get_logs_timer);
  },
  methods: {
    getStreamLogs() {
      let vm = this;
      vm.$store.dispatch("STREAMING_GET_STREAM_LOGS", {
        stream_id: vm.event.id,
        stream_key: vm.streamKey,
        sessionId: vm.event.session_id,
      }).then((response) => {
        const result = response.data;
        vm.logs = result.streamLogs;
        vm.stream_status = result.streamState;
      }).catch((error) => {
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.stream-tab-body {
  height: calc(100% - 400px);
  width: 100%;
  display: flex;
  flex-direction: column;

  .stream-tab-body-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    height: 65px;
  }

  .stream-tab-body-body {
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .stream-log-item {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      border-bottom: 1px solid #ddd;

      .stream-log-item-label {
        font-size: 16px;
        color: #333;
      }

      .stream-log-item-value {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>